import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  UPLOAD,
  IMPORT_MODEL,
  CONVERT_XML,
  IMPORT_FOLDER,
  IMPORT_FOLDER_CHECK
} from '../utils/cst';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  constructor(private httpClient: HttpClient) {}

  public uploadImage(formData) {
    return this.httpClient.post<any>(UPLOAD, formData);
  }

  public deleteImage(completeURL: string) {
    return this.httpClient.delete<any>(completeURL);
  }

  public importFolderCheck(data: FormData) {
    return this.httpClient.post<any>(IMPORT_FOLDER_CHECK, data);
  }

  public importFolder(data: FormData) {
    return this.httpClient.post<any>(IMPORT_FOLDER, data);
  }

  // Does not import project but only a model - EDIT: Does not exists in back
  public importJSON(file: FormData) {
    return this.httpClient.post<any>(IMPORT_MODEL, file);
  }

  public convertXMLToFiles(file: FormData) {
    return this.httpClient.post<any>(CONVERT_XML, file);
  }
}
